const compatModules = {};import * as Mod1 from "./discourse/adapters/discourse-reactions-adapter";
compatModules["discourse/adapters/discourse-reactions-adapter"] = Mod1;

export * as discourse$adapters$discourse__reactions__adapter$$__module from "./discourse/adapters/discourse-reactions-adapter";
export {
default as discourse$adapters$discourse__reactions__adapter$$default
} from "./discourse/adapters/discourse-reactions-adapter";
import * as Mod2 from "./discourse/adapters/discourse-reactions-custom-reaction";
compatModules["discourse/adapters/discourse-reactions-custom-reaction"] = Mod2;

export * as discourse$adapters$discourse__reactions__custom__reaction$$__module from "./discourse/adapters/discourse-reactions-custom-reaction";
export {
default as discourse$adapters$discourse__reactions__custom__reaction$$default
} from "./discourse/adapters/discourse-reactions-custom-reaction";
import * as Mod3 from "./discourse/components/discourse-reactions-actions-button";
compatModules["discourse/components/discourse-reactions-actions-button"] = Mod3;

export * as discourse$components$discourse__reactions__actions__button$$__module from "./discourse/components/discourse-reactions-actions-button";
export {
default as discourse$components$discourse__reactions__actions__button$$default
} from "./discourse/components/discourse-reactions-actions-button";
import * as Mod4 from "./discourse/components/discourse-reactions-actions-summary";
compatModules["discourse/components/discourse-reactions-actions-summary"] = Mod4;

export * as discourse$components$discourse__reactions__actions__summary$$__module from "./discourse/components/discourse-reactions-actions-summary";
export {
default as discourse$components$discourse__reactions__actions__summary$$default
} from "./discourse/components/discourse-reactions-actions-summary";
import * as Mod5 from "./discourse/components/discourse-reactions-actions";
compatModules["discourse/components/discourse-reactions-actions"] = Mod5;

export * as discourse$components$discourse__reactions__actions$$__module from "./discourse/components/discourse-reactions-actions";
export {
resetCurrentReaction as discourse$components$discourse__reactions__actions$$resetCurrentReaction,
default as discourse$components$discourse__reactions__actions$$default
} from "./discourse/components/discourse-reactions-actions";
import * as Mod6 from "./discourse/components/discourse-reactions-counter";
compatModules["discourse/components/discourse-reactions-counter"] = Mod6;

export * as discourse$components$discourse__reactions__counter$$__module from "./discourse/components/discourse-reactions-counter";
export {
default as discourse$components$discourse__reactions__counter$$default
} from "./discourse/components/discourse-reactions-counter";
import * as Mod7 from "./discourse/components/discourse-reactions-double-button";
compatModules["discourse/components/discourse-reactions-double-button"] = Mod7;

export * as discourse$components$discourse__reactions__double__button$$__module from "./discourse/components/discourse-reactions-double-button";
export {
default as discourse$components$discourse__reactions__double__button$$default
} from "./discourse/components/discourse-reactions-double-button";
import * as Mod8 from "./discourse/components/discourse-reactions-list-emoji";
compatModules["discourse/components/discourse-reactions-list-emoji"] = Mod8;

export * as discourse$components$discourse__reactions__list__emoji$$__module from "./discourse/components/discourse-reactions-list-emoji";
export {
default as discourse$components$discourse__reactions__list__emoji$$default
} from "./discourse/components/discourse-reactions-list-emoji";
import * as Mod9 from "./discourse/components/discourse-reactions-list";
compatModules["discourse/components/discourse-reactions-list"] = Mod9;

export * as discourse$components$discourse__reactions__list$$__module from "./discourse/components/discourse-reactions-list";
export {
default as discourse$components$discourse__reactions__list$$default
} from "./discourse/components/discourse-reactions-list";
import * as Mod10 from "./discourse/components/discourse-reactions-picker";
compatModules["discourse/components/discourse-reactions-picker"] = Mod10;

export * as discourse$components$discourse__reactions__picker$$__module from "./discourse/components/discourse-reactions-picker";
export {
default as discourse$components$discourse__reactions__picker$$default
} from "./discourse/components/discourse-reactions-picker";
import * as Mod11 from "./discourse/components/discourse-reactions-reaction-button";
compatModules["discourse/components/discourse-reactions-reaction-button"] = Mod11;

export * as discourse$components$discourse__reactions__reaction__button$$__module from "./discourse/components/discourse-reactions-reaction-button";
export {
default as discourse$components$discourse__reactions__reaction__button$$default
} from "./discourse/components/discourse-reactions-reaction-button";
import * as Mod12 from "./discourse/components/discourse-reactions-reaction-emoji";
compatModules["discourse/components/discourse-reactions-reaction-emoji"] = Mod12;

export * as discourse$components$discourse__reactions__reaction__emoji$$__module from "./discourse/components/discourse-reactions-reaction-emoji";
export {
default as discourse$components$discourse__reactions__reaction__emoji$$default
} from "./discourse/components/discourse-reactions-reaction-emoji";
import * as Mod13 from "./discourse/components/discourse-reactions-state-panel-reaction";
compatModules["discourse/components/discourse-reactions-state-panel-reaction"] = Mod13;

export * as discourse$components$discourse__reactions__state__panel__reaction$$__module from "./discourse/components/discourse-reactions-state-panel-reaction";
export {
default as discourse$components$discourse__reactions__state__panel__reaction$$default
} from "./discourse/components/discourse-reactions-state-panel-reaction";
import * as Mod14 from "./discourse/components/discourse-reactions-state-panel";
compatModules["discourse/components/discourse-reactions-state-panel"] = Mod14;

export * as discourse$components$discourse__reactions__state__panel$$__module from "./discourse/components/discourse-reactions-state-panel";
export {
default as discourse$components$discourse__reactions__state__panel$$default
} from "./discourse/components/discourse-reactions-state-panel";
import * as Mod15 from "./discourse/connectors/user-activity-bottom/discourse-reactions-user-activity-reactions.gjs";
compatModules["discourse/connectors/user-activity-bottom/discourse-reactions-user-activity-reactions"] = Mod15;

export * as discourse$connectors$user__activity__bottom$discourse__reactions__user__activity__reactions$$__module from "./discourse/connectors/user-activity-bottom/discourse-reactions-user-activity-reactions.gjs";
export {
default as discourse$connectors$user__activity__bottom$discourse__reactions__user__activity__reactions$$default
} from "./discourse/connectors/user-activity-bottom/discourse-reactions-user-activity-reactions.gjs";
import * as Mod16 from "./discourse/connectors/user-notifications-bottom/discourse-reactions-user-notification-reactions.gjs";
compatModules["discourse/connectors/user-notifications-bottom/discourse-reactions-user-notification-reactions"] = Mod16;

export * as discourse$connectors$user__notifications__bottom$discourse__reactions__user__notification__reactions$$__module from "./discourse/connectors/user-notifications-bottom/discourse-reactions-user-notification-reactions.gjs";
export {
default as discourse$connectors$user__notifications__bottom$discourse__reactions__user__notification__reactions$$default
} from "./discourse/connectors/user-notifications-bottom/discourse-reactions-user-notification-reactions.gjs";
import * as Mod17 from "./discourse/controllers/user-activity/reactions";
compatModules["discourse/controllers/user-activity/reactions"] = Mod17;

export * as discourse$controllers$user__activity$reactions$$__module from "./discourse/controllers/user-activity/reactions";
export {
default as discourse$controllers$user__activity$reactions$$default
} from "./discourse/controllers/user-activity/reactions";
import * as Mod18 from "./discourse/discourse-reactions-user-activity-route-map";
compatModules["discourse/discourse-reactions-user-activity-route-map"] = Mod18;

export * as discourse$discourse__reactions__user__activity__route__map$$__module from "./discourse/discourse-reactions-user-activity-route-map";
export {
default as discourse$discourse__reactions__user__activity__route__map$$default
} from "./discourse/discourse-reactions-user-activity-route-map";
import * as Mod19 from "./discourse/discourse-reactions-user-notifications-route-map";
compatModules["discourse/discourse-reactions-user-notifications-route-map"] = Mod19;

export * as discourse$discourse__reactions__user__notifications__route__map$$__module from "./discourse/discourse-reactions-user-notifications-route-map";
export {
default as discourse$discourse__reactions__user__notifications__route__map$$default
} from "./discourse/discourse-reactions-user-notifications-route-map";
import * as Mod20 from "./discourse/initializers/discourse-reactions";
compatModules["discourse/initializers/discourse-reactions"] = Mod20;

export * as discourse$initializers$discourse__reactions$$__module from "./discourse/initializers/discourse-reactions";
export {
default as discourse$initializers$discourse__reactions$$default
} from "./discourse/initializers/discourse-reactions";
import * as Mod21 from "./discourse/initializers/reactions-admin-plugin-configuration-nav";
compatModules["discourse/initializers/reactions-admin-plugin-configuration-nav"] = Mod21;

export * as discourse$initializers$reactions__admin__plugin__configuration__nav$$__module from "./discourse/initializers/reactions-admin-plugin-configuration-nav";
export {
default as discourse$initializers$reactions__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/reactions-admin-plugin-configuration-nav";
import * as Mod22 from "./discourse/models/discourse-reactions-custom-reaction";
compatModules["discourse/models/discourse-reactions-custom-reaction"] = Mod22;

export * as discourse$models$discourse__reactions__custom__reaction$$__module from "./discourse/models/discourse-reactions-custom-reaction";
export {
PAGE_SIZE as discourse$models$discourse__reactions__custom__reaction$$PAGE_SIZE,
default as discourse$models$discourse__reactions__custom__reaction$$default
} from "./discourse/models/discourse-reactions-custom-reaction";
import * as Mod23 from "./discourse/routes/user-activity/reactions";
compatModules["discourse/routes/user-activity/reactions"] = Mod23;

export * as discourse$routes$user__activity$reactions$$__module from "./discourse/routes/user-activity/reactions";
export {
default as discourse$routes$user__activity$reactions$$default
} from "./discourse/routes/user-activity/reactions";
import * as Mod24 from "./discourse/routes/user-notifications/reactions-received";
compatModules["discourse/routes/user-notifications/reactions-received"] = Mod24;

export * as discourse$routes$user__notifications$reactions__received$$__module from "./discourse/routes/user-notifications/reactions-received";
export {
default as discourse$routes$user__notifications$reactions__received$$default
} from "./discourse/routes/user-notifications/reactions-received";
import * as Mod25 from "./discourse/templates/user-activity/reactions";
compatModules["discourse/templates/user-activity/reactions"] = Mod25;

export * as discourse$templates$user__activity$reactions$$__module from "./discourse/templates/user-activity/reactions";
export {
default as discourse$templates$user__activity$reactions$$default
} from "./discourse/templates/user-activity/reactions";
export default compatModules;
